import React, { memo, useCallback, useEffect, useRef, useState } from "react";
import {
  Dimensions,
  StyleSheet,
  TouchableNativeFeedback,
  View,
  Image,
} from "react-native";
import { connect, useDispatch } from "react-redux";
import Text from "@components/AppText";
import colors from "@constants/color";
import AddnMinBtn from "@components/ProductDisplayUnit/AddnMinBtn";
import DiscountStrip from "@components/ProductDisplayUnit/DiscountStrip";
import { normalize, width } from "@components/ProductDisplayUnit/metrics";
import useCartActions from "@components/CMS/useCartActions";
import { useDebounce } from "@utils/debounce";

const { width: deviceWidth } = Dimensions.get("window");

const formatPrice = (price) => {
  return price.split(".");
};

const ProductListing = (props) => {
  const { data = {}, updateCart = () => {}, customerId } = props;
  let {
    price_tl_single_buy = "",
    mrp = "NA",
    short_name_hi = "NA",
    sku_id = "",
    discount,
    discount_type,
    product_image,
    custom_text,
    custom_symbol,
    custom_text_border,
    custom_text_background,
    price_per_unit,
    quantity,
    grammage,
    discounted_product,
  } = data;

  price_tl_single_buy = price_tl_single_buy.toString();

  const { addCart, isCartValueLoading } = useCartActions();

  const [isFirstTime, setIsFirstTime] = useState(true);

  const countRef = useRef(parseInt(quantity));
  const [count, setCount] = useState(parseInt(quantity));
  const debounceCount = useDebounce(count, 500);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!isFirstTime) {
      addCart(
        sku_id,
        customerId,
        (response) => {
          if ("quantityAdded" in response) {
            countRef.current = parseInt(response.quantityAdded, 10);
            setCount(parseInt(response.quantityAdded, 10));
          }
          updateCart();
        },
        debounceCount,
      );
    }
  }, [debounceCount]);

  useEffect(() => {
    countRef.current = parseInt(quantity);
    setIsFirstTime(true);
    setCount(parseInt(quantity));
  }, [data]);

  const onPlusPress = () => {
    countRef.current = countRef.current + 1;
    setCount(countRef.current);
    setIsFirstTime(false);
  };

  const onMinusPress = () => {
    countRef.current = countRef.current - 1;
    setCount(countRef.current);
    setIsFirstTime(false);
  };

  const imgUrl = product_image;

  return (
    <TouchableNativeFeedback disabled={true}>
      <View style={[styles2.container]}>
        <DiscountStrip discount_type={discount_type} discount={discount} />
        <View style={{ flexDirection: "row" }}>
          <Image
            resizeMode={"contain"}
            style={{
              width: normalize(100),
              height: normalize(100),
            }}
            source={
              imgUrl
                ? {
                    uri: imgUrl,
                  }
                : require("@assets/images/defaultImage.webp")
            }
          />
          <View
            style={{
              flex: 1,
              paddingLeft: normalize(8),
            }}
          >
            <Text
              style={styles2.productTitle}
              numberOfLines={2}
              ellipsizeMode="tail"
            >
              {/* Chukde जीरा साबुत 10 */}
              {short_name_hi}
            </Text>
            <View
              style={{
                marginBottom: normalize(10),
                flexDirection: "row",
              }}
            >
              <View
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Text bold style={{ fontSize: normalize(18) }}>
                  ₹{formatPrice(price_tl_single_buy)[0]}
                  {formatPrice(price_tl_single_buy)[1] && (
                    <Text bold style={{ fontSize: normalize(12) }}>
                      .{formatPrice(price_tl_single_buy)[1]}
                    </Text>
                  )}
                </Text>
              </View>
              <View
                style={{
                  marginHorizontal: normalize(14),
                  alignItems: "center",
                }}
              >
                <Text
                  style={{
                    ...styles2.mrp,
                    fontSize: normalize(15),
                    marginTop: normalize(6),
                    textDecorationLine:
                      parseFloat(mrp) !== parseFloat(price_tl_single_buy)
                        ? "line-through"
                        : "none",
                  }}
                >
                  ₹{mrp}
                </Text>
              </View>

              {price_per_unit ? (
                <View
                  style={{
                    // justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Text
                    style={[
                      styles2.price_per_unit,
                      { fontSize: normalize(13), marginTop: normalize(5) },
                    ]}
                  >
                    ({price_per_unit})
                  </Text>
                </View>
              ) : (
                <></>
              )}
            </View>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <View
                style={{
                  width: normalize(90),
                  borderWidth: 1,
                  borderColor: "rgba(0, 0, 0, 0.2)",
                  borderRadius: 6,
                  paddingLeft: normalize(15),
                  justifyContent: "center",
                  height: normalize(30),
                }}
              >
                <Text style={{ fontSize: normalize(14) }}>{grammage}</Text>
              </View>
              {!discounted_product && (
                <View style={{ marginLeft: "auto" }}>
                  <AddnMinBtn
                    width={normalize(100)}
                    onPressPlus={onPlusPress}
                    onPressMinus={onMinusPress}
                    isCartValueLoading={isCartValueLoading}
                    count={count}
                  />
                </View>
              )}
            </View>
          </View>
        </View>
        {custom_symbol && custom_text && custom_text.length > 0 ? (
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              marginTop: normalize(10),
              paddingRight: normalize(10),
              padding: 5,
              paddingHorizontal: 10,
              borderWidth: 1,
              borderRadius: 5,
              borderColor: custom_text_border,
              backgroundColor: custom_text_background,
            }}
          >
            <Image
              source={{ uri: custom_symbol }}
              style={{
                height: normalize(16),
                width: normalize(16),
              }}
            />
            <Text
              bold
              style={styles2.offertext}
              numberOfLines={1}
              ellipsizeMode="tail"
            >
              {custom_text}
            </Text>
          </View>
        ) : (
          <></>
        )}
      </View>
    </TouchableNativeFeedback>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.primaryBg,
    flex: 1,
  },
  row: {
    display: "flex",
    flexDirection: "row",
    paddingHorizontal: 10,
    justifyContent: "space-between",
    width: "100%",
  },
  column: { flex: 1, flexDirection: "column" },
  rowSpaced: { flex: 1, flexDirection: "row", justifyContent: "space-between" },
  column: { flex: 1, flexDirection: "column" },
  cardContainer: { marginTop: 8 },
  productName: {
    flex: 1,
    marginBottom: 8,
    textAlign: "left",
  },
  prodDetails: {
    flex: 1,
    marginVertical: 20,
    display: "flex",
    justifyContent: "flex-end",
    // marginLeft: 16
  },
  finalPrice: {
    flexDirection: "row",
    alignItems: "baseline",
    // marginBottom: 18,
    lineHeight: 20,
  },
  salePrice: {
    textDecorationLine: "line-through",
    marginLeft: 10,
    paddingBottom: 3.5,
    color: "#FF2E00",
    fontSize: 14,
    lineHeight: 16,
  },
  finalPriceText: { fontWeight: "bold" },
  imgContainer: {
    backgroundColor: colors.white,
    justifyContent: "center",
    // borderWidth: 1,
    // borderColor: colors.mercury,
    marginVertical: 20,
  },
  image: {
    width: deviceWidth / 3,
    height: deviceWidth / 3,
  },
  outOfStockTextContainer: {
    borderWidth: 1,
    borderColor: "#000",
    borderRadius: 3,
    backgroundColor: "#ddd",
  },
  outOfStockOverlay: {
    width: 65,
    height: 32,
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: 1,
  },
  outOfStockBtn: {
    flexDirection: "row",
    justifyContent: "center",
    borderWidth: 1,
    borderColor: colors.primary,
    paddingVertical: 5,
    borderRadius: 16,
    width: 160,
  },
  productTitle: {
    flex: 1,
    flexWrap: "wrap",
    lineHeight: 24,
  },
});

const styles2 = StyleSheet.create({
  container: {
    width: "100%",
    borderBottomWidth: 1,
    borderBottomColor: "rgba(0,0,0,0.1)",
    paddingTop: normalize(10),
    paddingBottom: normalize(15),
    paddingRight: normalize(15),
    paddingLeft: normalize(15),
    position: "relative",
    backgroundColor: "white",
  },
  productTitle: {
    fontSize: normalize(15),
    lineHeight: normalize(18),
    marginBottom: normalize(5),
  },
  mrp: {
    lineHeight: normalize(16),
    color: "rgba(0, 0, 0, 0.86)",
  },
  price_per_unit: {
    color: "rgba(0, 0, 0, 0.56)",
  },
  offertext: {
    color: "rgba(0, 0, 0, 0.56)",
    fontSize: normalize(13),
    marginLeft: normalize(6),
  },
});

function mapStateToProps({ products: { oosProducts = [] }, cart }) {
  return {
    oosProducts,
  };
}

export default memo(connect(mapStateToProps)(ProductListing));
